import {Injectable, signal} from '@angular/core';
import {HttpClient} from '@angular/common/http';
import {AppConfig} from '../../app.config';
import {map} from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class ForumTalkService {
  forumChatEnabled = signal(false);
  constructor (private http: HttpClient, private api: AppConfig) {}

  getBanners(page = 1, perPage = 50, sort = 'id', direction = 'ASC') {
    return this.http.get(this.api.baseUrl + '/forumTalkBanner?page=' + page + '&perPage=' + perPage + '&sort=' + sort + '&direction=' + direction,
      this.api.jsonTokenHeaders).pipe(
        map((banner: any) => {
          if (banner.dateFrom) {
            banner.dateFrom = new Date(banner.dateFrom);
          }
          if (banner.dateTo) {
            banner.dateTo = new Date(banner.dateTo);
          }
          return banner;
        })
    );
  }

  addBanner(data) {
    return this.http.post(this.api.baseUrl + '/forumTalkBanner', data, this.api.jsonTokenHeaders);
  }

  updateBanner(id, data) {
    return this.http.put(this.api.baseUrl + '/forumTalkBanner/' + id, data, this.api.jsonTokenHeaders);
  }

  deleteBanner(id) {
    return this.http.delete(this.api.baseUrl + '/forumTalkBanner/' + id, this.api.jsonTokenHeaders);
  }

  getNews(page = 1, perPage = 50, sort = 'id', direction = 'ASC') {
    return this.http.get(this.api.baseUrl + '/forumTalkNews?page=' + page + '&perPage=' + perPage + '&sort=' + sort + '&direction=' + direction,
      this.api.jsonTokenHeaders).pipe(
        map((news: any) => {
          if (news.date) {
            news.date = new Date(news.date);
          }
          return news;
        })
      );
  }

  addNews(data) {
    return this.http.post(this.api.baseUrl + '/forumTalkNews', data, this.api.jsonTokenHeaders);
  }

  updateNews(id, data) {
    return this.http.put(this.api.baseUrl + '/forumTalkNews/' + id, data, this.api.jsonTokenHeaders);
  }

  deleteNews(id) {
    return this.http.delete(this.api.baseUrl + '/forumTalkNews/' + id, this.api.jsonTokenHeaders);
  }

  getSystemTexts() {
    return this.http.get(this.api.baseUrl + '/forumTalkSystemText', this.api.jsonTokenHeaders);
  }

  addSystemText(data) {
    return this.http.post(this.api.baseUrl + '/forumTalkSystemText', data, this.api.jsonTokenHeaders);
  }

  updateSystemText(id, data) {
    return this.http.put(this.api.baseUrl + '/forumTalkSystemText/' + id, data, this.api.jsonTokenHeaders);
  }

  deleteSystemText(id) {
    return this.http.delete(this.api.baseUrl + '/forumTalkSystemText/' + id, this.api.jsonTokenHeaders);
  }

  getStatistics() {
    return this.http.get(this.api.baseUrl + '/synapseMatrix/statistics', this.api.jsonTokenHeaders);
  }
}
